import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Faq as Desk } from './desk'
import { Faq as Mob } from './mob'

type Props = {}

export const Faq: React.FC<Props> = () => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component />
}
